@if (profile(); as user) {
  <button
    type="button"
    class="flex items-center gap-3 rounded-xl px-2 py-1.5 text-left transition-colors hover:bg-gray-100"
    aria-haspopup="menu"
    [attr.aria-expanded]="open()"
    (click)="open.set(!open())"
  >
    <app-avatar size="sm" [src]="user.avatarThumbnailUrl" [name]="user.displayName" [seed]="user.id" />
    <span class="hidden sm:block min-w-0">
      <span class="block truncate font-medium text-gray-900">{{ user.displayName }}</span>
      @if (subtitle(); as text) {
        <span class="block truncate text-sm text-gray-500">{{ text }}</span>
      }
    </span>
    <app-icon name="chevron" class="hidden sm:inline-flex w-5 h-5 text-gray-500 transition-transform" [class.rotate-180]="open()" />
  </button>

  @if (open()) {
    <div role="menu" class="absolute right-0 top-full z-50 mt-2 w-48 overflow-hidden rounded-xl bg-white py-1 shadow-lg ring-1 ring-black/5">
      <button type="button" role="menuitem" class="block w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100" (click)="openProfile()">
        My profile
      </button>
      <button type="button" role="menuitem" class="block w-full px-4 py-2 text-left text-gray-700 hover:bg-red-50 hover:text-red-600" (click)="askLogout()">
        Logout
      </button>
    </div>
  }
}

@if (confirmingLogout()) {
  <app-logout-dialog (cancel)="confirmingLogout.set(false)" (confirm)="confirmLogout()" />
}
